import React from "react"
import Cabecalho from "../Cabecalho"
import { BairrosForm } from "./components/BairrosForm"

export function AtribuirRegiao() {
    return (
        <>
            <Cabecalho pagina="Bairros Atendidos" />
            <BairrosForm />
        </>
    )
}
